import { render, staticRenderFns } from "./MyCompany.vue?vue&type=template&id=cb4c3f68&"
import script from "./MyCompany.vue?vue&type=script&lang=ts&"
export * from "./MyCompany.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports